<div class="locataires-page">
  <a
    [routerLink]="routes.locataires"
    class="locataires-back"
    [title]="'common.backToList' | translate"
    [attr.aria-label]="'common.backToList' | translate"
    >
    <fa-icon icon="arrow-left"></fa-icon>
  </a>

  @if (loading) {
    <p class="locataires-status">{{ 'common.loading' | translate }}</p>
  }
  @if (error) {
    <p class="locataires-status locataires-status--error">
      {{ 'locataires.fiche.loadError' | translate }}
    </p>
  }

  @if (!loading && !error && locataire; as current) {
    @if (!editMode) {
      <header class="locataires-header">
        <div class="locataires-header-row">
          <div class="locataires-header-main">
            <h2 class="locataires-title">{{ fullName() }}</h2>
            <p class="locataires-subtitle">{{ logementLabel() }}</p>
            @if (current.densiteAlerteDto) {
              <p class="locataires-alert">
                <fa-icon icon="circle-info"></fa-icon>
                {{ 'locataires.densiteAlerte' | translate }}
              </p>
            }
            @if (current.activeDto === false) {
              <p class="locataires-badge">{{ 'locataires.inactif' | translate }}</p>
            }
          </div>
          <div class="locataires-header-actions">
            <button
              type="button"
              class="locataires-row-action"
              [title]="'locataires.fiche.edit' | translate"
              [attr.aria-label]="'locataires.fiche.edit' | translate"
              [disabled]="saving || deleting || reactivating"
              (click)="startEdit()"
              >
              <fa-icon icon="pen"></fa-icon>
            </button>
            @if (canSoftDelete() || canDeleteDefinitive()) {
              <button
                type="button"
                class="locataires-row-action locataires-row-action--danger"
                [title]="'locataires.fiche.delete' | translate"
                [attr.aria-label]="'locataires.fiche.delete' | translate"
                [disabled]="saving || deleting || reactivating"
                (click)="askDelete()"
                >
                <fa-icon [icon]="['far', 'trash-can']"></fa-icon>
              </button>
            }
          </div>
        </div>
        @if (canReactivate()) {
          <div class="locataires-status-actions">
            <button
              type="button"
              class="locataires-action-btn"
              [disabled]="saving || deleting || reactivating"
              (click)="askReactivate()"
              >
              <fa-icon icon="arrows-rotate"></fa-icon>
              {{ 'locataires.fiche.reactivate' | translate }}
            </button>
          </div>
        }
      </header>

      <section class="locataires-card">
        <dl class="locataires-details">
          <div>
            <dt>{{ 'locataires.fiche.civilite' | translate }}</dt>
            <dd>
              {{
                current.civiliteDto
                  ? (current.civiliteDto | i18nValue: 'ref.civilite')
                  : ('common.dash' | translate)
              }}
            </dd>
          </div>
          <div>
            <dt>{{ 'locataires.fiche.nom' | translate }}</dt>
            <dd>{{ current.nomDto || ('common.dash' | translate) }}</dd>
          </div>
          <div>
            <dt>{{ 'locataires.fiche.prenom' | translate }}</dt>
            <dd>{{ current.prenomDto || ('common.dash' | translate) }}</dd>
          </div>
          <div>
            <dt>{{ 'locataires.fiche.telephone' | translate }}</dt>
            <dd>{{ current.telephoneDto || ('common.dash' | translate) }}</dd>
          </div>
          <div>
            <dt>{{ 'locataires.fiche.email' | translate }}</dt>
            <dd>{{ current.mailDto || ('common.dash' | translate) }}</dd>
          </div>
          <div>
            <dt>{{ 'locataires.fiche.dateNaissance' | translate }}</dt>
            <dd>
              {{
                (current.dateNaissanceDto | date: 'dd/MM/yyyy') ||
                  ('common.dash' | translate)
              }}
            </dd>
          </div>
          <div>
            <dt>{{ 'locataires.fiche.villeNaissance' | translate }}</dt>
            <dd>{{ current.villeNaissanceDto || ('common.dash' | translate) }}</dd>
          </div>
          <div>
            <dt>{{ 'locataires.fiche.etudiant' | translate }}</dt>
            <dd>
              {{
                current.etudiantDto
                  ? ('common.yes' | translate)
                  : ('common.no' | translate)
              }}
            </dd>
          </div>
          <div>
            <dt>{{ 'locataires.fiche.logement' | translate }}</dt>
            <dd>{{ logementLabel() }}</dd>
          </div>
          <div>
            <dt>{{ 'locataires.fiche.dateEntree' | translate }}</dt>
            <dd>
              {{
                (current.dateEntreeDto | date: 'dd/MM/yyyy') ||
                  ('common.dash' | translate)
              }}
            </dd>
          </div>
          <div>
            <dt>{{ 'locataires.fiche.dateBail' | translate }}</dt>
            <dd>
              {{
                (current.dateBailDto | date: 'dd/MM/yyyy') ||
                  ('common.dash' | translate)
              }}
            </dd>
          </div>
          <div>
            <dt>{{ 'locataires.fiche.dateCles' | translate }}</dt>
            <dd>
              {{
                (current.dateClesDto | date: 'dd/MM/yyyy') ||
                  ('common.dash' | translate)
              }}
            </dd>
          </div>
          <div>
            <dt>{{ 'locataires.fiche.dureeBail' | translate }}</dt>
            <dd>{{ current.dureeBailDto || ('common.dash' | translate) }}</dd>
          </div>
        </dl>
      </section>
    }

    @if (editMode) {
      <header class="locataires-header">
        <h2 class="locataires-title">{{ 'locataires.fiche.edit' | translate }}</h2>
        <p class="locataires-subtitle">{{ fullName() }}</p>
      </header>

      <section class="locataires-card locataires-card--edit">
        <form class="locataires-form" [formGroup]="form" (ngSubmit)="save()">
          <app-locataire-form-fields
            [form]="form"
            [logements]="logements"
            [selectedMeuble]="selectedMeuble"
            [dureeBailHintKey]="dureeBailHintKey"
            [dureeBailErrorKey]="dureeBailErrorKey"
            [dureeBailInvalid]="dureeBailInvalid"
            />

          @if (formError) {
            <p class="locataires-status locataires-status--error">
              {{ 'locataires.fiche.saveError' | translate }}
            </p>
          }

          <div class="locataires-form-actions">
            <button
              type="button"
              class="locataires-cancel"
              [disabled]="saving"
              (click)="cancelEdit()"
              >
              {{ 'common.cancel' | translate }}
            </button>
            <button type="submit" class="locataires-action-btn" [disabled]="saving">
              {{
                saving
                  ? ('common.saving' | translate)
                  : ('common.save' | translate)
              }}
            </button>
          </div>
        </form>
      </section>
    }
  }

  <dialog
    #deleteDialog
    class="locataires-dialog"
    aria-labelledby="delete-locataire-title"
    (cancel)="onDeleteDialogCancel($event)"
    (click)="onDeleteDialogBackdropClick($event)"
    (keydown)="onDeleteDialogBackdropKeydown($event)"
    >
    @if (locataire; as current) {
      <h3 id="delete-locataire-title">
        {{ 'locataires.fiche.deleteChooserTitle' | translate }}
      </h3>
      <p>
        {{
          'locataires.fiche.deleteChooserBody'
            | translate
              : {
                  name:
                    (current.prenomDto || '') + ' ' + (current.nomDto || '')
                }
        }}
      </p>
      @if (canDeleteDefinitive()) {
        <p class="locataires-dialog-hint">
          {{ 'locataires.fiche.deleteDefinitiveHint' | translate }}
        </p>
      }
      @if (deleteError) {
        <p class="locataires-status locataires-status--error">
          {{ 'locataires.fiche.deleteError' | translate }}
        </p>
      }
      <div class="locataires-dialog-actions">
        <button
          type="button"
          class="locataires-cancel"
          [disabled]="deleting"
          (click)="cancelDelete()"
          >
          {{ 'common.cancel' | translate }}
        </button>
        @if (canSoftDelete()) {
          <button
            type="button"
            class="locataires-action-btn locataires-action-btn--danger"
            [disabled]="deleting"
            (click)="confirmDelete(false)"
            >
            {{
              deleting && !pendingDefinitiveDelete
                ? ('common.deleting' | translate)
                : ('locataires.fiche.deactivate' | translate)
            }}
          </button>
        }
        @if (canDeleteDefinitive()) {
          <button
            type="button"
            class="locataires-action-btn locataires-action-btn--danger"
            [disabled]="deleting"
            (click)="confirmDelete(true)"
            >
            {{
              deleting && pendingDefinitiveDelete
                ? ('common.deleting' | translate)
                : ('locataires.fiche.deleteDefinitive' | translate)
            }}
          </button>
        }
      </div>
    }
  </dialog>

  <dialog
    #reactivateDialog
    class="locataires-dialog"
    aria-labelledby="reactivate-locataire-title"
    (cancel)="onReactivateDialogCancel($event)"
    (click)="onReactivateDialogBackdropClick($event)"
    (keydown)="onReactivateDialogBackdropKeydown($event)"
    >
    @if (locataire; as current) {
      <h3 id="reactivate-locataire-title">
        {{ 'locataires.fiche.reactivateTitle' | translate }}
      </h3>
      <p>
        {{
          'locataires.fiche.reactivateBody'
            | translate
              : {
                  name:
                    (current.prenomDto || '') + ' ' + (current.nomDto || '')
                }
        }}
      </p>
      @if (reactivateError) {
        <p class="locataires-status locataires-status--error">
          {{ 'locataires.fiche.reactivateError' | translate }}
        </p>
      }
      <div class="locataires-dialog-actions">
        <button
          type="button"
          class="locataires-cancel"
          [disabled]="reactivating"
          (click)="cancelReactivate()"
          >
          {{ 'common.cancel' | translate }}
        </button>
        <button
          type="button"
          class="locataires-action-btn"
          [disabled]="reactivating"
          (click)="confirmReactivate()"
          >
          {{
            reactivating
              ? ('locataires.fiche.reactivating' | translate)
              : ('locataires.fiche.reactivate' | translate)
          }}
        </button>
      </div>
    }
  </dialog>
</div>
